export default __webpack_public_path__ + "static/media/double-rope-border-both.b6e5f035.svg";